export function FullExtent(state) {
  let result = {
    offsetX: state.offsetX,
    offsetY: state.offsetY,
    spacing: state.spacing,
  };
  if (!state.entities[0].details || state.entities[0].details.length === 0) {
    return result;
  }

  let newSpacing = state.spacing;
  let newOffsetX = state.offsetX;
  let newOffsetY = state.offsetY;
  let windowWidth = state.windowWidth;
  let windowHeight = state.windowHeight;
  let spacing = state.spacing;
  let entities = state.entities[0].details;
  let xmin = 0;
  let ymin = 0;
  let xmax = 0;
  let ymax = 0;

  if (
    state.selectedElement &&
    state.selectedElement.type === 'selectElement' &&
    state.tool === 'pointer'
  ) {
    xmin = entities[state.selectedElement.detailIndex].coordinates[0][0];
    xmax = entities[state.selectedElement.detailIndex].coordinates[0][0];
    ymin = entities[state.selectedElement.detailIndex].coordinates[0][1];
    ymax = entities[state.selectedElement.detailIndex].coordinates[0][1];

    for (
      let y = 0;
      y < entities[state.selectedElement.detailIndex].coordinates.length;
      y++
    ) {
      if (
        entities[state.selectedElement.detailIndex].coordinates[y][0] < xmin
      ) {
        xmin = entities[state.selectedElement.detailIndex].coordinates[y][0];
      }
      if (
        entities[state.selectedElement.detailIndex].coordinates[y][0] > xmax
      ) {
        xmax = entities[state.selectedElement.detailIndex].coordinates[y][0];
      }
      if (
        entities[state.selectedElement.detailIndex].coordinates[y][1] < ymin
      ) {
        ymin = entities[state.selectedElement.detailIndex].coordinates[y][1];
      }
      if (
        entities[state.selectedElement.detailIndex].coordinates[y][1] > ymax
      ) {
        ymax = entities[state.selectedElement.detailIndex].coordinates[y][1];
      }
    }
    for (
      let y = 0;
      y < entities[state.selectedElement.detailIndex].arcData.length;
      y++
    ) {
      if (
        entities[state.selectedElement.detailIndex].arcData[y].type ===
          'carc' &&
        entities[state.selectedElement.detailIndex].arcData[y].minor
      ) {
        let dragcoords = [
          entities[state.selectedElement.detailIndex].coordinates[y],
          entities[state.selectedElement.detailIndex].coordinates[y + 1],
        ];
        let draglength = calculateLength(dragcoords[0], dragcoords[1]);

        let arcPower =
          entities[state.selectedElement.detailIndex].arcData[y].power / 2;

        let radius = Math.abs(arcPower) / 2;
        let p = (radius + radius + draglength) / 2;
        let innerTriangleArea = Math.sqrt(
          Math.abs(p * (p - radius) * (p - radius) * (p - draglength)),
        );
        let centerLineLength = (innerTriangleArea * 2) / (draglength / 2);
        centerLineLength = radius - centerLineLength / 2;

        let arcCCoords = [
          [
            (dragcoords[1][0] + dragcoords[0][0]) / 2,
            (dragcoords[1][1] + dragcoords[0][1]) / 2,
          ],
          [dragcoords[0][0], dragcoords[0][1]],
        ];
        arcCCoords = [
          arcCCoords[0],
          rotatePoint(
            arcCCoords[0][0],
            arcCCoords[0][1],
            arcCCoords[1][0],
            arcCCoords[1][1],
            -90,
          ),
        ];
        let arcCFactor =
          dragcoords[0][0] === dragcoords[1][0] &&
          dragcoords[0][1] === dragcoords[1][1]
            ? 0
            : centerLineLength /
              Math.sqrt(
                Math.pow(Math.abs(arcCCoords[0][0] - arcCCoords[1][0]), 2) +
                  Math.pow(Math.abs(arcCCoords[0][1] - arcCCoords[1][1]), 2),
              );
        arcCCoords = [
          arcCCoords[0],
          [
            arcCCoords[0][0] +
              (arcCCoords[1][0] - arcCCoords[0][0]) * arcCFactor,
            arcCCoords[0][1] +
              (arcCCoords[1][1] - arcCCoords[0][1]) * arcCFactor,
          ],
        ];
        if (arcPower > 0) {
          arcCCoords = [
            arcCCoords[0],
            rotatePoint(
              arcCCoords[0][0],
              arcCCoords[0][1],
              arcCCoords[1][0],
              arcCCoords[1][1],
              180,
            ),
          ];
        }
        let center = arcCCoords[1];
        let arcPoints = [];
        arcPoints.push(center);
        // console.log('p:'+p);
        // console.log('radius:'+radius);
        // console.log('draglength:'+draglength);
        // console.log('coordinates');
        // console.log(entities[state.selectedElement.detailIndex].coordinates);
        // console.log('center');
        // console.log(center);
        // console.log('arcpoints');
        // console.log(arcPoints);
        for (let z = 0; z < arcPoints.length; z++) {
          if (arcPoints[z][0] < xmin) {
            xmin = arcPoints[z][0];
          }
          if (arcPoints[z][0] > xmax) {
            xmax = arcPoints[z][0];
          }
          if (arcPoints[z][1] < ymin) {
            ymin = arcPoints[z][1];
          }
          if (arcPoints[z][1] > ymax) {
            ymax = arcPoints[z][1];
          }
        }
      } else if (
        entities[state.selectedElement.detailIndex].arcData[y].type === 'carc'
      ) {
        let dragcoords = [
          entities[state.selectedElement.detailIndex].coordinates[y],
          entities[state.selectedElement.detailIndex].coordinates[y + 1],
        ];
        let draglength = calculateLength(dragcoords[0], dragcoords[1]);

        let arcPower =
          entities[state.selectedElement.detailIndex].arcData[y].power / 2;

        let radius = Math.abs(arcPower) / 2;
        let p = (radius + radius + draglength) / 2;
        let innerTriangleArea = Math.sqrt(
          Math.abs(p * (p - radius) * (p - radius) * (p - draglength)),
        );
        let centerLineLength = (innerTriangleArea * 2) / (draglength / 2);
        let arcCCoords = [
          [
            (dragcoords[1][0] + dragcoords[0][0]) / 2,
            (dragcoords[1][1] + dragcoords[0][1]) / 2,
          ],
          [dragcoords[0][0], dragcoords[0][1]],
        ];
        arcCCoords = [
          arcCCoords[0],
          rotatePoint(
            arcCCoords[0][0],
            arcCCoords[0][1],
            arcCCoords[1][0],
            arcCCoords[1][1],
            -90,
          ),
        ];
        let arcCFactor =
          dragcoords[0][0] === dragcoords[1][0] &&
          dragcoords[0][1] === dragcoords[1][1]
            ? 0
            : (centerLineLength * 1.8) /
              2 /
              Math.sqrt(
                Math.pow(Math.abs(arcCCoords[0][0] - arcCCoords[1][0]), 2) +
                  Math.pow(Math.abs(arcCCoords[0][1] - arcCCoords[1][1]), 2),
              );
        arcCCoords = [
          arcCCoords[0],
          [
            arcCCoords[0][0] +
              (arcCCoords[1][0] - arcCCoords[0][0]) * arcCFactor,
            arcCCoords[0][1] +
              (arcCCoords[1][1] - arcCCoords[0][1]) * arcCFactor,
          ],
        ];
        if (arcPower < 0) {
          arcCCoords = [
            arcCCoords[0],
            rotatePoint(
              arcCCoords[0][0],
              arcCCoords[0][1],
              arcCCoords[1][0],
              arcCCoords[1][1],
              180,
            ),
          ];
        }
        let center = arcCCoords[1];
        let arcPoints = [];
        arcPoints.push([center[0] + radius, center[1]]);
        arcPoints.push([center[0] - radius, center[1]]);
        arcPoints.push([center[0], center[1] + radius]);
        arcPoints.push([center[0], center[1] - radius]);
        // console.log('p:'+p);
        // console.log('radius:'+radius);
        // console.log('draglength:'+draglength);
        // console.log('coordinates');
        // console.log(entities[state.selectedElement.detailIndex].coordinates);
        // console.log('center');
        // console.log(center);
        // console.log('arcpoints');
        // console.log(arcPoints);
        for (let z = 0; z < arcPoints.length; z++) {
          if (arcPoints[z][0] < xmin) {
            xmin = arcPoints[z][0];
          }
          if (arcPoints[z][0] > xmax) {
            xmax = arcPoints[z][0];
          }
          if (arcPoints[z][1] < ymin) {
            ymin = arcPoints[z][1];
          }
          if (arcPoints[z][1] > ymax) {
            ymax = arcPoints[z][1];
          }
        }
      }
    }
    let size = state.textSettings.annotationSize * 0.75;
    for (let x = 0; x < state.entities[1].annotations.length; x++) {
      if (
        state.entities[1].annotations[x].detailIndices[0] ===
        state.selectedElement.detailIndex
      ) {
        let textLength = ('' + state.entities[1].annotations[x].content).length;
        let pixelLength = size * 0.65 * textLength;
        let coordinate = state.entities[1].annotations[x].coordinate;
        let textxmin = coordinate[0];
        let textymin = coordinate[1] - size;
        let textxmax = coordinate[0] + pixelLength;
        let textymax = coordinate[1];
        if (textxmin < xmin) {
          xmin = textxmin;
        } else if (textxmax > xmax) {
          xmax = textxmax;
        }
        if (textymin < ymin) {
          ymin = textymin;
        } else if (textymax > ymax) {
          ymax = textymax;
        }
      }
    }
  } else {
    xmin = entities[0].coordinates[0][0];
    xmax = entities[0].coordinates[0][0];
    ymin = entities[0].coordinates[0][1];
    ymax = entities[0].coordinates[0][1];

    for (let x = 0; x < entities.length; x++) {
      for (let y = 0; y < entities[x].coordinates.length; y++) {
        if (entities[x].coordinates[y][0] < xmin) {
          xmin = entities[x].coordinates[y][0];
        }
        if (entities[x].coordinates[y][0] > xmax) {
          xmax = entities[x].coordinates[y][0];
        }
        if (entities[x].coordinates[y][1] < ymin) {
          ymin = entities[x].coordinates[y][1];
        }
        if (entities[x].coordinates[y][1] > ymax) {
          ymax = entities[x].coordinates[y][1];
        }
      }
    }
    for (let x = 0; x < entities.length; x++) {
      for (let y = 0; y < entities[x].arcData.length; y++) {
        if (
          entities[x].arcData[y].type === 'carc' &&
          entities[x].arcData[y].minor
        ) {
          let dragcoords = [
            entities[x].coordinates[y],
            entities[x].coordinates[y + 1],
          ];
          let draglength = calculateLength(dragcoords[0], dragcoords[1]);

          let arcPower = entities[x].arcData[y].power / 2;

          let radius = Math.abs(arcPower) / 2;
          let p = (radius + radius + draglength) / 2;
          let innerTriangleArea = Math.sqrt(
            Math.abs(p * (p - radius) * (p - radius) * (p - draglength)),
          );
          let centerLineLength = (innerTriangleArea * 2) / (draglength / 2);
          centerLineLength = radius - centerLineLength / 2;

          let arcCCoords = [
            [
              (dragcoords[1][0] + dragcoords[0][0]) / 2,
              (dragcoords[1][1] + dragcoords[0][1]) / 2,
            ],
            [dragcoords[0][0], dragcoords[0][1]],
          ];
          arcCCoords = [
            arcCCoords[0],
            rotatePoint(
              arcCCoords[0][0],
              arcCCoords[0][1],
              arcCCoords[1][0],
              arcCCoords[1][1],
              -90,
            ),
          ];
          let arcCFactor =
            dragcoords[0][0] === dragcoords[1][0] &&
            dragcoords[0][1] === dragcoords[1][1]
              ? 0
              : centerLineLength /
                Math.sqrt(
                  Math.pow(Math.abs(arcCCoords[0][0] - arcCCoords[1][0]), 2) +
                    Math.pow(Math.abs(arcCCoords[0][1] - arcCCoords[1][1]), 2),
                );
          arcCCoords = [
            arcCCoords[0],
            [
              arcCCoords[0][0] +
                (arcCCoords[1][0] - arcCCoords[0][0]) * arcCFactor,
              arcCCoords[0][1] +
                (arcCCoords[1][1] - arcCCoords[0][1]) * arcCFactor,
            ],
          ];
          if (arcPower > 0) {
            arcCCoords = [
              arcCCoords[0],
              rotatePoint(
                arcCCoords[0][0],
                arcCCoords[0][1],
                arcCCoords[1][0],
                arcCCoords[1][1],
                180,
              ),
            ];
          }
          let center = arcCCoords[1];
          let arcPoints = [];
          arcPoints.push(center);
          // console.log('radius');
          // console.log(radius);
          // console.log('center');
          // console.log(center);
          // console.log('arcpoints');
          // console.log(arcPoints);
          for (let z = 0; z < arcPoints.length; z++) {
            if (arcPoints[z][0] < xmin) {
              xmin = arcPoints[z][0];
            }
            if (arcPoints[z][0] > xmax) {
              xmax = arcPoints[z][0];
            }
            if (arcPoints[z][1] < ymin) {
              ymin = arcPoints[z][1];
            }
            if (arcPoints[z][1] > ymax) {
              ymax = arcPoints[z][1];
            }
          }
        } else if (entities[x].arcData[y].type === 'carc') {
          let dragcoords = [
            entities[x].coordinates[y],
            entities[x].coordinates[y + 1],
          ];
          let draglength = calculateLength(dragcoords[0], dragcoords[1]);

          let arcPower = entities[x].arcData[y].power / 2;

          let radius = Math.abs(arcPower) / 2;
          let p = (radius + radius + draglength) / 2;
          let innerTriangleArea = Math.sqrt(
            Math.abs(p * (p - radius) * (p - radius) * (p - draglength)),
          );
          let centerLineLength = (innerTriangleArea * 2) / (draglength / 2);
          let arcCCoords = [
            [
              (dragcoords[1][0] + dragcoords[0][0]) / 2,
              (dragcoords[1][1] + dragcoords[0][1]) / 2,
            ],
            [dragcoords[0][0], dragcoords[0][1]],
          ];
          arcCCoords = [
            arcCCoords[0],
            rotatePoint(
              arcCCoords[0][0],
              arcCCoords[0][1],
              arcCCoords[1][0],
              arcCCoords[1][1],
              -90,
            ),
          ];
          let arcCFactor =
            dragcoords[0][0] === dragcoords[1][0] &&
            dragcoords[0][1] === dragcoords[1][1]
              ? 0
              : (centerLineLength * 1.8) /
                2 /
                Math.sqrt(
                  Math.pow(Math.abs(arcCCoords[0][0] - arcCCoords[1][0]), 2) +
                    Math.pow(Math.abs(arcCCoords[0][1] - arcCCoords[1][1]), 2),
                );
          arcCCoords = [
            arcCCoords[0],
            [
              arcCCoords[0][0] +
                (arcCCoords[1][0] - arcCCoords[0][0]) * arcCFactor,
              arcCCoords[0][1] +
                (arcCCoords[1][1] - arcCCoords[0][1]) * arcCFactor,
            ],
          ];
          if (arcPower < 0) {
            arcCCoords = [
              arcCCoords[0],
              rotatePoint(
                arcCCoords[0][0],
                arcCCoords[0][1],
                arcCCoords[1][0],
                arcCCoords[1][1],
                180,
              ),
            ];
          }
          let center = arcCCoords[1];
          let arcPoints = [];
          arcPoints.push([center[0] + radius, center[1]]);
          arcPoints.push([center[0] - radius, center[1]]);
          arcPoints.push([center[0], center[1] + radius]);
          arcPoints.push([center[0], center[1] - radius]);
          // console.log('radius');
          // console.log(radius);
          // console.log('center');
          // console.log(center);
          // console.log('arcpoints');
          // console.log(arcPoints);
          for (let z = 0; z < arcPoints.length; z++) {
            if (arcPoints[z][0] < xmin) {
              xmin = arcPoints[z][0];
            }
            if (arcPoints[z][0] > xmax) {
              xmax = arcPoints[z][0];
            }
            if (arcPoints[z][1] < ymin) {
              ymin = arcPoints[z][1];
            }
            if (arcPoints[z][1] > ymax) {
              ymax = arcPoints[z][1];
            }
          }
        }
      }
    }
    let size = state.textSettings.annotationSize;
    for (let x = 0; x < state.entities[1].annotations.length; x++) {
      let textLength = ('' + state.entities[1].annotations[x].content).length;
      let pixelLength = size * 0.65 * textLength;
      let coordinate = state.entities[1].annotations[x].coordinate;
      let textxmin = coordinate[0];
      let textymin = coordinate[1] - size;
      let textxmax = coordinate[0] + pixelLength;
      let textymax = coordinate[1];
      if (textxmin < xmin) {
        xmin = textxmin;
      } else if (textxmax > xmax) {
        xmax = textxmax;
      }
      if (textymin < ymin) {
        ymin = textymin;
      } else if (textymax > ymax) {
        ymax = textymax;
      }
    }
  }

  let xdiff = xmax - xmin;
  let ydiff = ymax - ymin;

  let adjustedxdiff = (xdiff / 10) * spacing;
  let adjustedydiff = (ydiff / 10) * spacing;

  let xunits = xdiff / 10;
  let yunits = ydiff / 10;
  let xwindowunits = Math.floor(windowWidth / spacing);
  let ywindowunits = Math.floor(windowHeight / spacing);

  if (adjustedxdiff > windowWidth || adjustedydiff > windowHeight) {
    for(let x=15;x>0;x-=0.5) {
      if (
        ((xdiff + 50) / 10) * x < windowWidth &&
        ((ydiff + 50) / 10) * x < windowHeight
      ) {
        newSpacing = x;
        xwindowunits = Math.floor(windowWidth / newSpacing);
        ywindowunits = Math.floor(windowHeight / newSpacing);
        newOffsetX = (xmin - 10) * -1;
        newOffsetX = Math.floor((xwindowunits - xunits) / 2) * 10 - xmin;
        newOffsetY = (ymin - 10) * -1;
        newOffsetY = Math.floor((ywindowunits - yunits) / 2) * 10 - ymin;
        x = 0;
      }
    }
  } else if (
    adjustedxdiff + 50 < windowWidth ||
    adjustedydiff + 50 < windowHeight
  ) {
    for(let x=15;x>0;x-=0.5) {
      if (
        ((xdiff + 50) / 10) * x < windowWidth &&
        ((ydiff + 50) / 10) * x < windowHeight
      ) {
        newSpacing = x;
        xwindowunits = Math.floor(windowWidth / newSpacing);
        ywindowunits = Math.floor(windowHeight / newSpacing);
        newOffsetX = (xmin - 10) * -1;
        newOffsetX = Math.floor((xwindowunits - xunits) / 2) * 10 - xmin;
        newOffsetY = (ymin - 10) * -1;
        newOffsetY = Math.floor((ywindowunits - yunits) / 2) * 10 - ymin;
        x = 0;
      }
    }
  } else if (
    xmin + state.offsetX < 0 ||
    xmax + state.offsetX > windowWidth ||
    ymin + state.offsetY < 0 ||
    ymax + state.offsetY > windowHeight
  ) {
    newSpacing = 10;
    xwindowunits = Math.floor(windowWidth / newSpacing);
    ywindowunits = Math.floor(windowHeight / newSpacing);
    newOffsetX = (xmin - 10) * -1;
    newOffsetX = Math.floor((xwindowunits - xunits) / 2) * 10 - xmin;
    newOffsetY = (ymin - 10) * -1;
    newOffsetY = Math.floor((ywindowunits - yunits) / 2) * 10 - ymin;
  }

  result = {
    offsetX: newOffsetX,
    offsetY: newOffsetY,
    spacing: newSpacing,
  };
  return result;
}

function calculateLength(start, target) {
  return Math.sqrt(
    Math.pow(Math.abs(start[0] - target[0]), 2) +
      Math.pow(Math.abs(start[1] - target[1]), 2),
  );
}

function rotatePoint(cx, cy, x, y, angle) {
  var radians = (Math.PI / 180) * angle,
    cos = Math.cos(radians),
    sin = Math.sin(radians),
    nx = cos * (x - cx) + sin * (y - cy) + cx,
    ny = cos * (y - cy) - sin * (x - cx) + cy;
  return [nx, ny];
}
